import { Component, OnInit, Output, OnChanges, Input, EventEmitter, inject, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { Distribution } from './models/distribution';
import { DocumentTypeEntity } from './models/distribution-object';
import { DistributionObjectService } from './services/distribution-object.service';
import { DocumentConfig } from './models/document-config';
import { GenericModalService, ModalSettingsMessage } from '../shared/generic-modal/generic-modal.service';
import { FormsModule } from '@angular/forms';

import { ApplicationInsightsService } from '../shared/insights/application-insights.service';

@Component({
    templateUrl: './distribution-create-new.component.html',
    selector: 'ep-distribution-create-new',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class DistributionCreateNewComponent implements OnInit, OnChanges {
    private appInsights = inject(ApplicationInsightsService);

    constructor(private distributionObjectService: DistributionObjectService, private modalService: GenericModalService) {
        this.appInsights.logEvent('DistributionCreateNew', { 'event': 'constructor' });
    }

    public newDistribution: Distribution = null;
    public distributionObjects: DocumentTypeEntity[] = new Array();
    public selectedDistributionObject: DocumentTypeEntity = null;

    @Input() isFallback: boolean = false;

    @Output() saved: EventEmitter<Distribution> = new EventEmitter<Distribution>();
    @Output() cancelled: EventEmitter<void> = new EventEmitter<void>();

    ngOnInit(): void {

        this.reset()

        this.distributionObjectService.getDocumentTypesForDistributions().then((distributionObjects) => {
            this.distributionObjects = distributionObjects.sort((d1, d2) => d1.Name.localeCompare(d2.Name));
        });
    }

    ngOnChanges(changes: any) {
        if (changes.isFallback) {
            this.isFallback = changes.isFallback.currentValue;

            //When isFallback value changes it is most likely due to the user going through the menu and chooseing to create a new distribution. Therefore reset the current distribution.
            this.reset();
        }
    }

    reset() {
        this.selectedDistributionObject = null;
        this.newDistribution = new Distribution();
        this.newDistribution.IsActive = true;
        this.newDistribution.DocumentConfigIn = new DocumentConfig();
        this.newDistribution.IsTemplate = this.isFallback; // isTemplate is obsolete but can't be removed at this point, so we will set it to the same value as isFallback for now.       
    }

    save() {
        this.appInsights.logEvent('DistributionCreateNew', { 'event': 'next' });

        //Todo: Form based validation..
        if (!this.selectedDistributionObject) {
            let settings = new ModalSettingsMessage('Required field', 'Please select a Distribution Object.');
            this.modalService.message(settings).then((e) => { }).catch((e) => { });
            return;
        }

        this.newDistribution.DocumentConfigIn.DistributionObject = this.selectedDistributionObject;

        //this.ngOnInit(); // Reset the component...
        this.saved.emit(this.newDistribution);
        this.reset();
    }

    cancel() {
        this.appInsights.logEvent('DistributionCreateNew', { 'event': 'cancel' });

        // this.ngOnInit();
        this.cancelled.emit();
    }
}
